const INITIAL_STATE = {
    languages: [],
    count: 0,
    loading: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "GET_LANGUAGES": {
            return {
                ...state,
                languages: action.languages,
                count: action.count,
                loading: false
            }
        }
        default:
            return state
    }
}
